import { Layout } from "@/components/layout/Layout";

import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiCollection, getStrapiEntity } from "@/utils/strapi";
import { VehicleType } from "@/components/common/searchBlock/children/vehicleTypeSelection/VehicleTypeSelection";
import { createQueryVehiclePage } from "@/strapiQuery/vehicle-page";
import { VehiclePageContent } from "@/components/pages/vehicle/Vehicle";
import { routes } from "@/routes/routes";
import { ReviewsConst } from "@/components/common/reviewsBlock/ReviewsBlock";
import { queryReviewsConst } from "@/strapiQuery/queryReviewsConst";

export const getStaticProps = async (ctx: LoadI18nMessagesProps) => {
  const layoutPromise = getStrapiEntity<Layout>("layout", "");
  const reviewsConst = await getStrapiEntity<ReviewsConst>(
    "reviews-const",
    queryReviewsConst
  );

  const vehiclePageContentPromise = getStrapiCollection<VehiclePageContent>(
    "vehicle-pages",
    createQueryVehiclePage(VehicleType.TRUCK)
  );

  const [layout, vehiclePageContent] = await Promise.all([
    layoutPromise,
    vehiclePageContentPromise,
  ]);

  const intlMessages = loadIntlMessages(ctx);

  return {
    props: {
      layout,
      reviewsConst,
      ...vehiclePageContent[0],
      intlMessages,
      defaultCanonicalRoute: routes.vehiclePageTruck,
    },
    revalidate: 10,
  };
};

export { Vehicle as default } from "@/components/pages/vehicle/Vehicle";
